import { useDispatch, useSelector } from 'react-redux';
import { GarageNetworkSearchParams } from '@apis/GarageNetworkApi';
import { garagesFetch } from './action';
import { selectGarageNetworkPage } from './selector';

export const useGarageNetworkPage = () => {
  const dispatch = useDispatch();
  const { garages, isLoading, error, pagination, searchParams } = useSelector(selectGarageNetworkPage);

  const fetchGarages = (params?: GarageNetworkSearchParams) => {
    dispatch(garagesFetch(params));
  };

  return {
    garages,
    isLoading,
    error,
    pagination,
    searchParams,
    fetchGarages,
  };
};
